import { useEffect, useState } from 'react'

/**
 * 입력값이 delayMs 동안 바뀌지 않을 때만 값을 갱신해 반환.
 * 서버 검색 입력에서 키 입력마다 요청이 나가는 것을 방지.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value)
    }, delayMs)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delayMs])

  return debounced
}
